/* eslint-disable */
import keyBy from 'lodash/keyBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  contacts: { byId: {}, allIds: [] },
  conversations: { byId: {}, allIds: [] },
  activeConversationId: null,
  participants: [],
  recipients: [],
  ut: 0,
  notifications: []

};

const slice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // STOP LOADING
    stopLoading(state) {
      state.isLoading = false;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    // get notifications about unread message

    getNotifications(state, action) {
      const ntf = action.payload;
      state.notifications = ntf;
    },

    // get ut (update time)

    getUpdateTime(state, action) {
      const ut = action.payload;
      state.ut = ut;
    },

    // GET CONTACT SSUCCESS
    getContactsSuccess(state, action) {
      const contacts = action.payload;

      state.contacts.byId = keyBy(contacts, 'id');
      state.contacts.allIds = Object.keys(state.contacts.byId);
    },

    // GET CONVERSATIONS
    getConversationsSuccess(state, action) {
      const conversations = action.payload;

      conversations.forEach((conversation) => {
        const existingConversation = state.conversations.byId[conversation.id];
        if (existingConversation) {
          state.conversations.byId[conversation.id] = {
            ...conversation,
            messages: existingConversation.messages || [],
          };
        } else {
          state.conversations.byId[conversation.id] = {
            ...conversation,
            messages: [],
          };
        }
      });

      state.conversations.allIds = Object.keys(state.conversations.byId);
    },

    // GET UPD MESSAGES ARR
    getNewMessagesSuccess(state, action) {
      const mess = action.payload;

      if (mess && mess.length > 0) {
        const notifications = [];
        mess.forEach(item => {
          const newMess = item.messages;
          if (item.conversationKey) {
            notifications.push({ id: item.conversationKey, count: item.messages.length });
            const conversation = state.conversations.byId[item.conversationKey];
            const convMessages = state.conversations.byId[item.conversationKey].messages;
            const nMess = [...convMessages, ...newMess]
            const clearNewMess = nMess.filter(item => typeof item.id !== 'string')
            state.conversations.byId[item.conversationKey] = {
              ...conversation,
              messages: clearNewMess
            }
          }
        });
        state.notifications = notifications;

      }
    },

    // GET CONVERSATION
    getConversationSuccess(state, action) {
      const conversation = action.payload;

      if (conversation) {
        const preview = state.conversations.byId[conversation.id]?.preview;
        state.conversations.byId[conversation.id] = { ...conversation, preview: preview };
        state.activeConversationId = conversation.id;
        if (!state.conversations.allIds.includes(conversation.id)) {
          state.conversations.allIds.push(conversation.id);
        }
      } else {
        state.activeConversationId = null;
      }
    },

    // ON SEND MESSAGE
    sendMessage(state, action) {

      const conversation = action.payload;
      const { conversationId, messageId, message, contentType, attachments, createdAt, senderId } =
        conversation;

      const newMessage = {
        id: messageId,
        body: message,
        contentType,
        attachments,
        createdAt,
        senderId: "",
      };

      state.conversations.byId[conversationId].messages.push(newMessage);
    },

    markConversationAsReadSuccess(state, action) {
      const { conversationId } = action.payload;
      const conversation = state.conversations.byId[conversationId];
      if (conversation) {
        conversation.unreadCount = 0;
      }
    },

    // GET PARTICIPANTS
    getParticipantsSuccess(state, action) {
      const participants = action.payload;
      state.participants = participants;
    },

    // RESET ACTIVE CONVERSATION
    resetActiveConversation(state) {
      state.activeConversationId = null;
    },

    addRecipients(state, action) {
      const recipients = action.payload;
      state.recipients = recipients;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { addRecipients, sendMessage, resetActiveConversation, getParticipantsSuccess, getUpdateTime, getNotifications } = slice.actions;

// ----------------------------------------------------------------------

export function getContacts(shopId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/chat/contacts', { params: { shop_id: shopId } });
      dispatch(slice.actions.getContactsSuccess(response.data.contacts));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getUpdateMessages(ut, shopId) {

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/conversations/updates?ut=${ut}`, { params: { shop_id: shopId } }); // /api/chat/conversations

      dispatch(slice.actions.getNewMessagesSuccess(response.data.data.messages));
      dispatch(slice.actions.getUpdateTime(response.data.data.ut));
      dispatch(slice.actions.stopLoading());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      // dispatch(slice.actions.stopLoading());
    }
  };
}

export function getConversations(shopId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/conversations', { params: { shop_id: shopId } }); // /api/chat/conversations

      dispatch(slice.actions.getConversationsSuccess(response.data.data.conversations));
      dispatch(slice.actions.stopLoading());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(slice.actions.stopLoading());
    }
  };
}

// ----------------------------------------------------------------------

export function getConversation(conversationKey, shopId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      // /api/chat/conversation
      const response = await axios.get('/conversation', {
        params: { conversationKey, shop_id: shopId },
      });

      dispatch(slice.actions.getConversationSuccess(response.data.data.conversation));
      dispatch(slice.actions.stopLoading());
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      dispatch(slice.actions.stopLoading());
    }
  };
}

// ----------------------------------------------------------------------

export function markConversationAsRead(conversationId, shopId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.get('/conversation/mark-as-seen', {
        params: { conversationKey: conversationId, shop_id: shopId },
      });
      dispatch(slice.actions.markConversationAsReadSuccess({ conversationId }));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function getParticipants(conversationKey, shopId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('/api/chat/participants', {
        params: { conversationKey, shop_id: shopId },
      });
      dispatch(slice.actions.getParticipantsSuccess(response.data.participants));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}


export function onSendMessage(conversationId, newMessage, shopId) {

  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.post(`/conversation?conversationKey=${conversationId}&shop_id=${shopId}`, newMessage);

      // dispatch(slice.actions.sendMessage({...newMessage , conversationId}));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
